import {styled, Tabs} from "@mui/material";

export const UserTabs = styled(Tabs)(() => ({
    borderTopRightRadius: '0.5rem',
    borderTopLeftRadius: '0.5rem',
    backgroundColor: '#fff',
    borderBottom: '1px solid #CFCFE0',
}));

export const SettingsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '125px'
}));

export const SettingsTabContainer = styled('div')(() => ({
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    gap: '1rem',
    width: '100%'
}));

